import {
  ArtistProfileTemplate,
  SectionFieldType,
  SectionTemplateKey,
} from '../../../api/public';

const ARTIST_PROFILE_TEMPLATES: ArtistProfileTemplate[] = [
  {
    key: SectionTemplateKey.FULL_WIDTH_VIDEO,
    name: 'Full Width Video',
    description: 'Showcase your work with an immersive video',
    fields: [
      {
        key: 'videoUrl',
        label: 'Upload 16:9 Video',
        type: SectionFieldType.VIDEO,
      },
      { key: 'title', label: 'Video title', type: SectionFieldType.TEXT },
    ],
  },
  {
    key: SectionTemplateKey.VIDEO_TEXT,
    name: 'Video + Text',
    description: 'Combine video with descriptive context',
    fields: [
      {
        key: 'videoUrl',
        label: 'Upload Video',
        type: SectionFieldType.VIDEO,
        group: 'media',
      },
      {
        key: 'title',
        label: 'Title',
        type: SectionFieldType.TEXT,
        group: 'content',
      },
      {
        key: 'description',
        label: 'Description',
        type: SectionFieldType.TEXTAREA,
        group: 'content',
      },
      {
        key: 'layout',
        label: 'Layout',
        type: SectionFieldType.SELECT,
        options: ['Video Left', 'Video Right'],
      },
    ],
  },
  {
    key: SectionTemplateKey.IMAGE_TEXT,
    name: 'Image + Text',
    description: 'Pair imagery with compelling narrative',
    fields: [
      {
        key: 'imageUrl',
        label: 'Upload Photo',
        type: SectionFieldType.IMAGE,
        group: 'media',
      },
      {
        key: 'title',
        label: 'Title',
        type: SectionFieldType.TEXT,
        group: 'content',
      },
      {
        key: 'description',
        label: 'Description',
        type: SectionFieldType.TEXTAREA,
        group: 'content',
      },
      {
        key: 'layout',
        label: 'Layout',
        type: SectionFieldType.SELECT,
        options: ['Image Left', 'Image Right'],
      },
    ],
  },
  {
    key: SectionTemplateKey.DOUBLE_IMAGE,
    name: 'Double Image',
    description: 'Display two images side by side',
    fields: [
      {
        key: 'imageUrlLeft',
        label: 'Upload Photo',
        type: SectionFieldType.IMAGE,
        group: 'left',
      },
      {
        key: 'imageUrlRight',
        label: 'Upload Photo',
        type: SectionFieldType.IMAGE,
        group: 'right',
      },
    ],
  },
  {
    key: SectionTemplateKey.FULL_WIDTH_IMAGE,
    name: 'Full Width Image',
    description: 'Present a single powerful image',
    fields: [
      { key: 'imageUrl', label: 'Upload Photo', type: SectionFieldType.IMAGE },
      { key: 'caption', label: 'Caption', type: SectionFieldType.TEXT },
    ],
  },
];

const useArtistProfileTemplates = () => {
  return { templates: ARTIST_PROFILE_TEMPLATES };
};

export default useArtistProfileTemplates;
